import React from "react";
import PropTypes from "prop-types"
import {Table, Badge} from 'antd';
import {NavLink} from "react-router-dom"
import {defaultPagination, onlyUnique, toFilterItem} from "../../util/Util"

const SiteTable = ({dataSource, onSelectChange, loading}) => {
    const columns = [
        {title: 'Country', dataIndex: 'country', filters: dataSource.map(d => d.country).filter(onlyUnique).map(toFilterItem), width:95},
        {title: 'aPureBase Id', dataIndex: 'apurebaseId', render: (text, record) => <NavLink to={`/site/${record.id}`}>{text}</NavLink>, width:105},
        {
            title: 'Status',
            dataIndex: 'active',
            render: active => <Badge status={active ? 'success' : 'default'}/>, width:60
        },
        {title: 'Site Name', dataIndex: 'siteName', width:100},
        {title: 'Department', dataIndex: 'department', width: 300},
        {title: 'Street', dataIndex: 'street', width:100},
        {title: 'City', dataIndex: 'city', filters: dataSource.map(d => d.city).filter(onlyUnique).map(toFilterItem), width:100},
        {title: 'Specialties', dataIndex: 'specialties', width: 250}

    ];
    
    const rowSelection = {
        type: 'radio',
        onChange: (selectedRowKeys, selectedRows) => {
            if (selectedRowKeys.length > 0) onSelectChange(selectedRowKeys[0])
        }
    };
    
    return <Table dataSource={dataSource} loading={loading}
                  columns={columns} size="small" bordered
                  rowKey={record => record.id}
                  rowSelection={rowSelection} pagination={defaultPagination()}
    />
};

SiteTable.propTypes = {
    dataSource: PropTypes.array.isRequired,
    onSelectChange: PropTypes.func,
    loading: PropTypes.bool.isRequired
};

export default SiteTable


// WEBPACK FOOTER //
// ./src/js/browse/site/SiteTable.js